
export function initialize(object:any, package_root:string='') {
	return {
		'fingerprint': object.fingerprint,
		'language fingerprint': object['language fingerprint'],
		root: init(object['root'], package_root)
	};
}
export function init(object:any, package_root:string) {
	package_root = package_root + 'package';
	const path = '';
	return {
		'client_bindings.alan': new ManifestFile(package_root + path + '/client_bindings.alan' + object['type'][1]['children']['client_bindings.alan']['inode']['type'][1].suffix, package_root + path + '/client_bindings.alan.symtab')
	}

}
export class ManifestFile {
	constructor(readonly path: string, readonly sympath: string) {};
}
